// @flow

type AudioFile = {
  title: string,
  desc: string,
  text?: boolean,
  lang: string,
};

type Action = {
  type: 'FETCH_SCRIBE_TRAINING_SUCCESS',
  trainings: Array<AudioFile>,
};

type State = Array<AudioFile>;

const initialState: Array<AudioFile> = [];

export default function scribeTrainings(
  state: State = initialState,
  action: Action
): State {
  switch (action.type) {
    case 'FETCH_SCRIBE_TRAINING_SUCCESS':
      return action.trainings;

    default:
      // eslint-disable-next-line no-unused-expressions
      (action: empty);
      return state;
  }
}
